import React, { Component, isValidElement } from "react";
import ReactMarkdown from "react-markdown";
import InformationCircle from "../../resources/icons/InformationCircle.jsx";
class ChatUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chatSelected: this.props.chatSelected,
      chatId: this.props.chatId,
      userId: this.props.userId,
      userInfo: null,
      userName: this.props.userName || "",
      lastMessageText: "",
      lastMessageTime: 0,
      newMessages: 0,
      isSelected: false,
    };
  }
  static getDerivedStateFromProps(nextProps, prevProps) {
    return {
      chatSelected: nextProps.chatSelected,
      lastMessageText: nextProps.lastMessageText,
      lastMessageTime: nextProps.lastMessageTime,
      newMessages: nextProps.newMessages,
      isSelected: nextProps.isSelected,
    };
  }
  componentDidMount() {
    this.loadUserInfo();
  }
  loadUserInfo() {
    console.log("load_user_info");
    let my = this;
    if (localStorage.getItem("user_type") === "tutor") {
      fetch(this.props.mentorChatApiRoot + "/student/info", {
        method: "POST",
        cache: "no-cache",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token: localStorage.getItem("mentor_chat_token"),
          user_id: parseInt(this.state.userId),
        }),
      })
        .then((res) => res.json())
        .then(
          (result) => {
            my.setState({ userInfo: result });
          },
          (error) => {
            console.log(error);
          }
        );
    }
  }
  getTimeFromTs(ts) {
    if (ts == 0) {
      return "";
    } else {
      let date =
        new Date(ts).getDate().toString().padStart(2, "0") +
        "." +
        (new Date(ts).getMonth() + 1).toString().padStart(2, "0") +
        "." +
        new Date(ts).getFullYear().toString();

      let date_now =
        new Date().getDate().toString().padStart(2, "0") +
        "." +
        (new Date().getMonth() + 1).toString().padStart(2, "0") +
        "." +
        new Date().getFullYear().toString();

      if (date == date_now) {
        return (
          new Date(ts).getHours().toString().padStart(2, "0") +
          ":" +
          new Date(ts).getMinutes().toString().padStart(2, "0") +
          ":" +
          new Date(ts).getSeconds().toString().padStart(2, "0")
        );
      } else {
        return date;
      }
    }
  }
  render() {
    const { userInfo } = this.state;
    return (
      <div
        className="ChatUserTuple"
        style={{
          backgroundColor: this.state.isSelected ? "#eaeaea" : "#FFF",
        }}
        onClick={() => {
          this.props.selectChat(
            this.state.chatId,
            this.state.isSelected,
            this.state.userName
          );
          if (window.innerHeight > window.innerWidth) {
            this.props.closeUsersList();
          }
        }}
      >
        {userInfo && (
          <div
            className="ChatUserInfo"
            style={{
              display:
                localStorage.getItem("user_type") === "tutor" ? "flex" : "none",
            }}
          >
            <InformationCircle
              color="#707070"
              height="20px"
              width="20px"
            ></InformationCircle>
            <div className="ChatUserInfoBox">
              <table>
                <tbody>
                  {Object.keys(userInfo)
                    .sort()
                    .map((key) => (
                      <tr>
                        <td>{key}</td>
                        <td>{userInfo[key]}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
        <div className="ChatUserHeader">
          <div className="ChatUserName">{this.state.userName}</div>
          <div className="ChatUserLastMessageTime">
            {this.getTimeFromTs(this.state.lastMessageTime * 1000)}
          </div>
        </div>
        <div className="ChatUserLastMessageContainer">
          <div className="ChatUserLastMessage">
            <ReactMarkdown>
              {this.state.lastMessageText.length > 60
                ? this.state.lastMessageText.substring(0, 59) + "..."
                : this.state.lastMessageText}
            </ReactMarkdown>
          </div>
          <div
            className="ChatUserNewMessages"
            style={{ opacity: this.state.newMessages ? 1 : 0 }}
          >
            {this.state.newMessages || ""}
          </div>
        </div>
      </div>
    );
  }
}

export default ChatUser;
